import React, { useEffect, useState } from "react";
import DocumentLibraryIcon from "../../assets/icons/library_documents.svg2";
import PageHeader from "../Common/PageHeader";
import LibraryLinks from "./LibraryLinks";
import { proxyAPI } from "../proxyAPI";
import WorkflowFilesList from "./WorkflowFilesList";

export default function DocumentTemplateLibrary() {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  const projectToOption = (project) => ({
    value: project.UUID,
    label: project.Label || project.UUID,
    data: project,
  });

  const loadProjectOptions = async (inputValue = "") => {
    const params = new URLSearchParams({
      limit: "20",
      order: "created",
      direction: "desc",
    });
    if (inputValue) {
      params.set("label", inputValue);
    }

    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `list-projects?${params.toString()}`,
    });

    return (data?.projects || []).map(projectToOption);
  };

  useEffect(() => {
    const loadProjects = async () => {
      const data = await proxyAPI({
        prefix: "logic/workflows/api",
        url: "list-projects?limit=20&order=created&direction=desc",
      });
      const projectList = data?.projects || [];
      setProjects(projectList);
    };

    loadProjects();
  }, []);

  return (
    <div>
      <PageHeader
        Icon={DocumentLibraryIcon}
        heading="Document Library"
        subheading="Access the files stored and used across Logic."
      />
      <LibraryLinks />

      <WorkflowFilesList
        projectUuid={selectedProject?.value || ""}
        projects={projects.map(projectToOption)}
        selectedProject={selectedProject}
        onProjectChange={setSelectedProject}
        loadProjectOptions={loadProjectOptions}
      />
    </div>
  );
}
